import { navFr } from "./modules/nav.fr";
import { dealsFr } from "./modules/deals.fr";
import { dealShowFr } from "./modules/deal_show.fr";
import { dealImportFr } from "./modules/deal_import.fr";
import { reportsFr } from "./modules/reports.fr";
import { exportFr } from "./modules/export.fr";
import { dashboardFr } from "./modules/dashboard.fr";
import { dialerFr } from "./modules/dialer.fr";
import { softphoneFr } from "./modules/softphone.fr";
import { automationFr } from "./modules/automation.fr";
import { notificationsFr } from "./modules/notifications.fr";
import { healthFr } from "./modules/health.fr";
// GAVION: batch 7
import { privacyFr } from "./modules/privacy.fr";
import { callSettingsFr } from "./modules/call_settings.fr";
// GAVION X1: daily goals and leaderboard
import { goalsFr } from "./modules/goals.fr";
// GAVION X3: data quality
import { dataQualityFr } from "./modules/data_quality.fr";
// GAVION open-pixel: Paramètres → Courriels
import { emailSettingsFr } from "./modules/email_settings.fr";
// GAVION batch 6
import { meetingsFr } from "./modules/meetings.fr";
// GAVION batch 6
import { integrationsFr } from "./modules/integrations.fr";
// GAVION batch 3: M365 catalogs
import { integrationsM365Fr } from "./modules/integrations.m365.fr";
import { systemSenderFr } from "./modules/system_sender.fr"; // GAVION pw-reset-delegated
import { stripeFr } from "./modules/stripe.fr"; // GAVION stripe-sync
import { composeFr } from "./modules/compose.fr";
// GAVION batch 5: email catalogs (src/components/gavion/email/i18n)
import { emailFr } from "../email/i18n";
// GAVION X2: objection library
import { objectionsFr } from "./modules/objections.fr";
// GAVION X5: best call hours
import { callHoursFr } from "./modules/call_hours.fr";
// GAVION A10: Profile password change
import { profilePasswordFr } from "./modules/profile_password.fr";
// GAVION training (« Formation »)
import { trainingFr } from "./modules/training.fr";
// GAVION rep stats
import { repStatsFr } from "./modules/rep_stats.fr";
import { costsFr } from "./modules/costs.fr";
import { sessionsFr } from "./modules/sessions.fr"; // GAVION team sessions
import { aiFr } from "./modules/ai.fr"; // GAVION ai-email
import { bookingFr } from "./modules/booking.fr"; // GAVION booking
import { testModeFr } from "./modules/test_mode.fr"; // GAVION test mode
import { pipelineFr } from "./modules/pipeline.fr"; // GAVION custom pipeline
import { leadStatusesFr } from "./modules/lead_statuses.fr"; // GAVION lead statuses
import { commissionsFr } from "./modules/commissions.fr"; // GAVION commissions
import { commissionsSettingsFr } from "./modules/commissions_settings.fr";
import { commissionsClientFr } from "./modules/commissions_client.fr";
import { commissionsReportsFr } from "./modules/commissions_reports.fr";
import { sendPipelineFr } from "./modules/send_pipeline.fr"; // GAVION call-brief-pipeline
import { callBriefFr } from "./modules/call_brief.fr"; // GAVION call-brief-pipeline
import { recruitingFr } from "./modules/recruiting.fr"; // GAVION recruiting
import { emailArchiveFr } from "./modules/email_archive.fr"; // GAVION full-email
import { callbacksFr } from "./modules/callbacks.fr"; // GAVION skip-callback
import { tasksFr } from "./modules/tasks.fr"; // GAVION tasks page
export const gavionFrMessages = {
  gavion: {
    login: {
      title: "Connexion",
      microsoft: "Se connecter avec Microsoft",
      or: "ou",
      submit: "Se connecter",
      forgot: "Mot de passe oublié ?",
      forgot_ask_admin:
        "La réinitialisation par courriel n'est pas encore active. Demandez à un administrateur un lien de mot de passe (Paramètres → Utilisateurs → Lien de mot de passe).",
      back_to_login: "Retour à la connexion",
      // GAVION self-service password reset (gavion-password-reset)
      forgot_details:
        "Entrez votre courriel : si un compte existe, vous recevrez un lien pour choisir un nouveau mot de passe.",
      forgot_submit: "Recevoir le lien",
      forgot_sent:
        "Si un compte existe pour cette adresse, un courriel a été envoyé. Le lien est valide 30 minutes et ne sert qu'une seule fois.",
      forgot_fallback:
        "Rien reçu après quelques minutes ? Vérifiez vos courriels indésirables, puis demandez à un administrateur un lien de mot de passe (Paramètres → Utilisateurs → Lien de mot de passe).",
      forgot_error:
        "La demande n'a pas pu être envoyée. Réessayez, ou demandez à un administrateur un lien de mot de passe.",
      dismiss: "Fermer",
      tagline: "Votre entreprise, toujours en ligne.",
      bullets: {
        faster_calls: "Appels plus rapides",
        auto_followups: "Relances automatiques",
        one_place: "Tout au même endroit",
      },
      errors: {
        invalid_credentials: "Courriel ou mot de passe invalide.",
        disabled: "Ce compte est désactivé. Contactez un administrateur.",
        not_invited:
          "Aucun compte Gavion CRM pour cette adresse. Demandez une invitation à un administrateur.",
        network: "Connexion impossible. Vérifiez votre réseau.",
        rate_limited: "Trop de tentatives. Réessayez dans quelques minutes.",
        unknown: "Une erreur est survenue. Réessayez.",
      },
    },
    users: {
      title: "Utilisateurs",
      invite: "Inviter un utilisateur",
      role: { admin: "Administrateur", rep: "Représentant" },
      status: { active: "Actif", invited: "Invité", disabled: "Désactivé" },
      can_dial: "Peut appeler",
      integration_state: {
        connected: "Oui",
        needs_reauth: "À reconnecter",
        error: "Erreur",
        none: "Non",
      },
      resend: "Renvoyer l'invitation",
      password_link: "Lien de mot de passe",
      revoke: "Annuler l'invitation",
      disable: "Désactiver",
      enable: "Réactiver",
      last_admin: "Impossible : il doit rester au moins un administrateur.",
      never: "Jamais",
      retry: "Réessayer",
      load_error: "Impossible de charger les utilisateurs.",
      confirm_disable: "Désactiver %{name} ? Ses sessions seront fermées.",
      columns: {
        name: "Nom",
        email: "Courriel",
        role: "Rôle",
        status: "Statut",
        last_sign_in: "Dernière connexion",
        microsoft: "Microsoft connecté",
        granola: "Granola connecté",
        actions: "Actions",
      },
      dialog: {
        first_name: "Prénom",
        last_name: "Nom",
        email: "Courriel",
        role: "Rôle",
        locale: "Langue",
        locale_fr: "Français",
        locale_en: "Anglais",
        send: "Envoyer",
        confirm: "Confirmer",
        cancel: "Annuler",
      },
      link: {
        created:
          "Invitation créée. Envoie ce lien à %{name} (par Teams ou courriel). Il est valide 24 h et utilisable une seule fois.",
        private_window:
          "Ouvre le lien dans une fenêtre privée si tu le testes toi-même.",
        field: "Lien d'invitation",
        copy: "Copier le lien",
        password_created:
          "Envoie ce lien à %{name}. Il est valide 24 h et utilisable une seule fois.",
        password_field: "Lien de mot de passe",
        copied: "Lien copié !",
        copy_failed: "Sélectionne le lien et fais Ctrl+C",
        close: "Fermer",
      },
      toast: {
        invited: "Invitation envoyée.",
        resent: "Invitation renvoyée.",
        revoked: "Invitation annulée.",
        role_changed: "Rôle mis à jour.",
        disabled: "Utilisateur désactivé.",
        enabled: "Utilisateur réactivé.",
        can_dial: "Droit d'appel mis à jour.",
      },
      errors: {
        invalid_email: "Saisissez un courriel valide.",
        first_name_required: "Le prénom est obligatoire.",
        last_name_required: "Le nom est obligatoire.",
        invalid_role: "Rôle invalide.",
        invalid_locale: "Langue invalide.",
        invalid_id: "Identifiant invalide.",
        invalid_disabled: "Valeur invalide.",
        invalid_can_dial: "Valeur invalide.",
        already_invited: "Ce courriel a déjà une invitation en attente.",
        already_member: "Ce courriel appartient déjà à un utilisateur.",
        forbidden: "Action réservée aux administrateurs.",
        invitation_not_found: "Invitation introuvable ou déjà traitée.",
        not_found: "Utilisateur introuvable.",
        unknown: "Une erreur est survenue. Réessayez.",
      },
    },
    common: {
      language: "Langue",
      sign_out_all: "Se déconnecter de tous les appareils",
    },
    // GAVION batch 1: leads, lead page, timeline and CSV import catalogs
    prospect_status: {
      new: "Nouveau",
      in_progress: "En cours",
      callback: "Rappel",
      demo_booked: "Démo réservée",
      in_pipeline: "En pipeline", // GAVION call-brief-pipeline
      not_interested: "Pas intéressé",
      bad_number: "Mauvais numéro",
      do_not_call: "Ne pas appeler",
      customer: "Client",
      cooling_down: "En pause",
    },
    // Libellés du dernier appel à côté du statut (badge, filtre « Dernier appel »)
    lead_status: {
      no_answer: "Pas de réponse",
      voicemail: "Message laissé",
      callback: "Callback",
      brochure_sent: "Brochure envoyée",
      demo_booked: "Démo bookée",
      not_interested: "Pas intéressé",
      age: {
        minutes: "il y a %{n} min",
        hours: "il y a %{n} h",
        days: "il y a %{n} j",
      },
    },
    call_outcome: {
      no_answer: "Pas de réponse",
      voicemail: "Message laissé",
      talked_callback: "Parlé – rappeler",
      demo_booked: "Démo réservée",
      brochure_sent: "Brochure envoyée",
      not_interested: "Pas intéressé",
      wrong_number: "Mauvais numéro",
      do_not_call: "Ne pas appeler",
      unlogged: "Non consigné",
      skipped: "Passé",
    },
    leads: {
      title: "Compagnies",
      views: {
        today: "À appeler aujourd'hui",
        callbacks: "Rappels",
        mine: "Mes compagnies",
        unassigned: "Non assignées",
        demos: "Démos",
        dnc: "Ne pas appeler",
        all: "Toutes",
      },
      columns: {
        name: "Entreprise",
        trade: "Métier",
        city: "Ville",
        phone: "Téléphone",
        status: "Statut",
        last_called_at: "Dernier appel",
        next_callback_at: "Prochain rappel",
        attempts: "Tentatives",
        assigned: "Assigné à",
        score: "Score",
      },
      filters: {
        title: "Filtres",
        search: "Rechercher",
        trade: "Métier",
        region: "Région",
        city: "Ville",
        status: "Statut",
        last_outcome: "Dernier appel",
        never_called: "Jamais appelée",
        score_min: "Score min.",
        score_max: "Score max.",
        has_email: "A un courriel",
        high_quality: "Haute qualité",
        assigned: "Assigné à",
        unassigned: "Non assigné",
        tags: "Étiquettes",
        date_added_from: "Ajoutée depuis le",
        date_added_to: "Ajoutée jusqu'au",
        more: "Autres critères",
        assigned_by_view: "Fixé par la vue",
      },
      badges: { locked: "En cours d'appel", dnc: "Ne pas appeler" },
      bulk: {
        title: "Actions groupées",
        tag: "Étiqueter",
        tag_title: "Ajouter une étiquette",
        tag_label: "Étiquette",
        assign: "Assigner",
        assign_title: "Assigner à un représentant",
        assign_to: "Représentant",
        unassign: "Non assigné",
        dnc: "Ne pas appeler",
        dnc_confirm_title:
          "Marquer %{smart_count} compagnie « Ne pas appeler » ? |||| Marquer %{smart_count} compagnies « Ne pas appeler » ?",
        dnc_confirm_body:
          "Les numéros sont ajoutés à la liste de suppression. Seul un administrateur peut les retirer.",
        apply: "Appliquer",
        cancel: "Annuler",
        done_assign:
          "%{smart_count} compagnie assignée |||| %{smart_count} compagnies assignées",
        done_assign_partial: "%{ok}/%{total} compagnies assignées",
        done_dnc:
          "%{smart_count} compagnie marquée « Ne pas appeler » |||| %{smart_count} compagnies marquées « Ne pas appeler »",
        done_tag: "Étiquette ajoutée",
        // GAVION B1-T7 polish: partial bulk tag result
        done_tag_partial: "%{ok}/%{total} compagnies taguées",
        tag_failed:
          "%{failed} compagnie non taguée. Elle reste sélectionnée. |||| %{failed} compagnies non taguées. Elles restent sélectionnées.",
        error: "L'action a échoué. Réessayez.",
        not_allowed: "Action non autorisée pour votre rôle.",
      },
      empty: {
        today: "Aucune compagnie à appeler pour le moment.",
        callbacks: "Aucun rappel prévu.",
        default: "Aucune compagnie ne correspond.",
      },
      overdue: "En retard",
      clear_filters: "Effacer les filtres",
      load_error: "Impossible de charger les compagnies.",
      retry: "Réessayer",
    },
    // GAVION company-create: « Créer … » in the company field of the contact / deal form
    company_create: {
      pending: "Création de « %{item} »…",
      existing: "Entreprise existante sélectionnée : %{name}",
      invalid_name: "Le nom de l'entreprise est vide.",
      error:
        "L'entreprise n'a pas pu être créée. Vérifiez votre connexion et réessayez.",
      choose: {
        title: "Plusieurs entreprises s'appellent « %{name} »",
        description:
          "Choisissez la bonne succursale, ou créez une nouvelle entreprise.",
        create_anyway: "Créer quand même",
        cancel: "Annuler",
      },
    },
    lead: {
      header: {
        add_note: "Ajouter une note",
        more: "Plus d'actions",
        assign: "Assigner…",
        assign_me: "M'assigner",
        dnc: "Ne pas appeler",
        delete: "Supprimer",
        locked: "Verrouillé : appel en cours",
      },
      sections: {
        coordinates: "Coordonnées",
        prospecting: "Prospection",
        contacts: "Contacts",
        deals: "Deals ouverts",
        tags: "Étiquettes",
      },
      fields: {
        phone: "Téléphone",
        email: "Courriel",
        website: "Site web",
        address: "Adresse",
        map: "Voir sur la carte",
        segment: "Segment",
        fit_score: "Score",
        high_quality: "Haute qualité",
        employees: "Employés (est.)",
        ops_contact: "Responsable des opérations", // GAVION ops-lookup
        attempts: "Tentatives",
        last_outcome: "Dernier résultat",
        last_called_at: "Dernier appel",
        next_callback_at: "Prochain rappel",
        cooldown_until: "En pause jusqu'au",
        date_added: "Ajouté le",
        source_query: "Source",
        assigned: "Assigné à",
        unassigned: "Non assigné",
        yes: "Oui",
        no: "Non",
      },
      no_contacts: "Aucun contact",
      add_contact: "Ajouter un contact", // GAVION company-create
      no_deals: "Aucun deal ouvert",
      note: {
        title: "Nouvelle note",
        placeholder: "Votre note…",
        save: "Enregistrer",
        saved: "Note ajoutée",
        empty: "La note est vide.",
      },
      // GAVION: lead edit (« Modifier »)
      edit: {
        button: "Modifier",
        shortcut_hint: "Raccourci : E",
        title: "Modifier la compagnie",
        description:
          "Les champs gérés par le système (assignation, appels, score) ne sont pas modifiables ici.",
        sections: {
          identity: "Entreprise",
          coordinates: "Coordonnées",
          address: "Adresse",
          prospecting: "Prospection",
          notes: "Notes internes",
        },
        fields: {
          name: "Nom de l'entreprise",
          phone_number: "Téléphone",
          phone_hint: "Numéro nord-américain à 10 chiffres, ex. 450 655-1865",
          email: "Courriel",
          website: "Site web",
          address: "Adresse",
          city: "Ville",
          state_abbr: "Province",
          zipcode: "Code postal",
          region: "Région",
          sector: "Métier",
          sector_none: "— Aucun —",
          timezone: "Fuseau horaire",
          language: "Langue",
          language_fr: "Français",
          language_en: "Anglais",
          segment: "Segment",
          estimated_employees: "Employés (est.)",
          ops_contact_name: "Responsable des opérations", // GAVION ops-lookup
          ops_contact_role: "Son rôle", // GAVION ops-lookup
          high_quality: "Haute qualité",
          prospect_status: "Statut de prospection",
          prospect_status_hint:
            "Le statut affiché tient aussi compte du dernier résultat d'appel.",
          prospect_status_dnc:
            "Cette compagnie est sur la liste Ne pas appeler : son statut ne se modifie pas ici.",
          description: "Description / notes internes",
        },
        cancel: "Annuler",
        save: "Enregistrer",
        saved: "Compagnie mise à jour",
        no_changes: "Aucune modification.",
        phone_taken: "Ce numéro appartient déjà à une autre compagnie",
        phone_taken_link: "Voir %{name}",
        errors: {
          name_required: "Le nom de l'entreprise est obligatoire.",
          ops_contact_too_long: "120 caractères au plus.", // GAVION ops-lookup
          phone_invalid:
            "Numéro invalide : entrez un numéro nord-américain à 10 chiffres.",
          email_invalid: "Adresse courriel invalide.",
          status_dnc: "Utilisez l'action « Ne pas appeler » pour ce statut.",
          forbidden:
            "Vous n'avez pas la permission de modifier cette compagnie ou l'un de ces champs.",
          generic: "La mise à jour a échoué. Réessayez.",
          unknown_status:
            "Ce statut a été supprimé entre-temps. Rechargez la page et choisissez-en un autre.",
        },
      },
    },
    timeline: {
      title: "Historique",
      filters: {
        all: "Tout",
        calls: "Appels",
        notes: "Notes",
        emails: "Courriels",
        meetings: "Réunions",
        tasks: "Tâches",
      },
      kind: {
        call: "Appel",
        // GAVION batch 6
        meeting_note: "Notes Granola",
        company_note: "Note",
        contact_note: "Note de contact",
        deal_note: "Note de deal",
        task: "Tâche terminée",
      },
      empty: "Aucune activité pour l'instant.",
      load_more: "Afficher plus",
      error: "Impossible de charger l'historique.",
      retry: "Réessayer",
      duration: "%{minutes} min %{seconds} s",
      by: "par %{name}",
      imported: "Importé",
    },
    lead_import: {
      button: "Importer",
      title: "Importer des compagnies (CSV)",
      steps: {
        upload: "Fichier",
        mapping: "Colonnes",
        options: "Options",
        preview: "Aperçu",
        import: "Import",
      },
      upload: {
        hint: "CSV en UTF-8 ou Windows-1252, 20 000 lignes au maximum.",
        choose: "Fichier CSV",
        too_large: "Fichier trop volumineux — utilisez le script d'import",
        empty: "Le fichier ne contient aucune ligne.",
        encoding: "Encodage détecté : %{encoding}",
        rows: "%{smart_count} ligne lue |||| %{smart_count} lignes lues",
        read_error: "Impossible de lire le fichier.",
      },
      mapping: {
        column: "Colonne du fichier",
        field: "Champ",
        ignore: "Ignorer",
        required: "Requis : le nom, et un téléphone ou un courriel.",
        missing_required:
          "Associez la colonne du nom et une colonne téléphone ou courriel.",
        missing_column: "colonne obligatoire manquante : %{column}",
      },
      fields: {
        name: "Entreprise",
        trade: "Métier",
        phone: "Téléphone",
        email: "Courriel",
        website: "Site web",
        city: "Ville",
        region: "Région",
        address: "Adresse",
        zipcode: "Code postal",
        owner_name: "Propriétaire",
        estimated_employees: "Employés (est.)",
        high_quality: "Haute qualité",
        segment: "Segment",
        source_query: "Requête source",
        fit_score: "Score",
        date_added: "Date d'ajout",
        source_id: "ID source",
      },
      options: {
        assign: "Assigner à",
        unassigned: "Non assigné",
        tag: "Étiquette (facultatif)",
        no_tag: "Aucune",
        duplicates: "Doublons",
        skip: "Ignorer les doublons",
        fill_blanks: "Compléter les champs vides",
      },
      preview: {
        title: "Aperçu des 20 premières lignes",
        row: "Ligne",
        status: "Statut",
        valid: "%{smart_count} ligne valide |||| %{smart_count} lignes valides",
        invalid:
          "%{smart_count} ligne rejetée |||| %{smart_count} lignes rejetées",
        ok: "OK",
        will_update: "Sera complété",
        checking: "Vérification des numéros…",
      },
      reasons: {
        missing_name: "Nom manquant",
        missing_phone_or_email: "Téléphone ou courriel requis",
        invalid_phone: "Téléphone invalide",
        duplicate_in_file: "Doublon dans le fichier",
        suppressed: "Numéro sur la liste « Ne pas appeler »",
        existing_lead: "Compagnie existante",
        invalid_row: "Ligne invalide",
        invalid_date: "Date invalide (AAAA-MM-JJ)",
        ambiguous_phone: "Téléphone en double dans le fichier et déjà en base",
        not_sent: "Non envoyé",
        // GAVION import duplicates
        possible_duplicate: "Doublon possible",
        match_gone: "Compagnie à compléter introuvable",
      },
      // GAVION import duplicates: the report's « Doublons possibles » section
      duplicates: {
        title: "Doublons possibles (%{count})",
        intro:
          "Ces lignes ressemblent à une compagnie déjà dans le CRM. Choisissez quoi faire, puis « Appliquer ». Les lignes laissées sur « Ignorer » restent dans les lignes rejetées.",
        looks_like: "ressemble à",
        file_row: "ligne %{line} du fichier",
        others: "+ %{smart_count} autre |||| + %{smart_count} autres",
        reason_name_city: "même nom et ville",
        reason_website: "même site web et nom",
        choice: "Décision pour la ligne %{line}",
        ignore: "Ignorer",
        fill: "Compléter la compagnie existante",
        create: "Créer quand même",
        apply_all: "Appliquer à tous",
        apply: "Appliquer",
        applying: "Envoi…",
        error: "L'envoi a échoué. Réessayez.",
        uncertain:
          "La connexion a été coupée pendant l'envoi : certaines lignes ont peut-être déjà été créées. Rechargez la liste des compagnies pour vérifier avant de réessayer.",
      },
      run: {
        start:
          "Importer %{smart_count} ligne |||| Importer %{smart_count} lignes",
        progress: "Import en cours… %{done} / %{total}",
        done: "Import terminé",
        imported:
          "%{smart_count} compagnie importée |||| %{smart_count} compagnies importées",
        updated:
          "%{smart_count} compagnie complétée |||| %{smart_count} compagnies complétées",
        rejected:
          "%{smart_count} ligne rejetée |||| %{smart_count} lignes rejetées",
        download_rejected: "Télécharger les lignes rejetées",
        reason_column: "Raison",
        error: "L'import a échoué. Réessayez.",
        issue: "Ligne %{line} : %{reason}",
        stop: "Arrêter",
        cancelled: "Import arrêté",
        not_sent:
          "%{smart_count} ligne non envoyée |||| %{smart_count} lignes non envoyées",
      },
      nav: { next: "Suivant", back: "Retour", close: "Fermer" },
    },
    // GAVION batch 4: per-feature catalogs (src/components/gavion/i18n/modules)
    nav: navFr,
    deals: dealsFr,
    deal_show: dealShowFr,
    deal_import: dealImportFr,
    reports: reportsFr,
    export: exportFr,
    dashboard: dashboardFr,
    dialer: dialerFr,
    softphone: softphoneFr,
    automation: automationFr,
    notifications: notificationsFr,
    health: healthFr,
    // GAVION: batch 7
    privacy: privacyFr,
    call_settings: callSettingsFr,
    // GAVION X1
    goals: goalsFr,
    // GAVION X3
    data_quality: dataQualityFr,
    // GAVION open-pixel
    email_settings: emailSettingsFr,
    // GAVION batch 6
    meetings: meetingsFr,
    // GAVION batch 3: M365 keys merged into the batch 6 integrations catalog (batch 6 wins on shared error keys)
    integrations: {
      ...integrationsM365Fr,
      ...integrationsFr,
      errors: { ...integrationsM365Fr.errors, ...integrationsFr.errors },
      // GAVION pw-reset-delegated
      system_sender: systemSenderFr,
      // GAVION stripe-sync
      stripe: stripeFr,
    },
    compose: composeFr,
    // GAVION batch 5
    email: emailFr,
    // GAVION X2
    objections: objectionsFr,
    // GAVION X5
    call_hours: callHoursFr,
    profile_password: profilePasswordFr,
    // GAVION training
    training: trainingFr,
    // GAVION rep stats
    rep_stats: repStatsFr,
    costs: costsFr,
    sessions: sessionsFr, // GAVION team sessions
    // GAVION ai-email
    ai: aiFr,
    call_brief: callBriefFr, // GAVION call-brief-pipeline
    send_pipeline: sendPipelineFr, // GAVION call-brief-pipeline
    booking: bookingFr, // GAVION booking
    test_mode: testModeFr, // GAVION test mode
    pipeline: pipelineFr, // GAVION custom pipeline
    lead_statuses: leadStatusesFr, // GAVION lead statuses
    // GAVION commissions (each screen task owns its module)
    commissions: commissionsFr,
    commissions_settings: commissionsSettingsFr,
    commissions_client: commissionsClientFr,
    commissions_reports: commissionsReportsFr,
    recruiting: recruitingFr, // GAVION recruiting
    email_archive: emailArchiveFr, // GAVION full-email
    callbacks: callbacksFr, // GAVION skip-callback
    tasks: tasksFr, // GAVION tasks page
  },
} as const;
